import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type NoticeType = 'success' | 'info' | 'warning' | 'error' | 'open';

type TNoticeState = {
  message: string | null;
  type: NoticeType | null;
};

// Тип обещал string, а начальное значение было null — теперь честно nullable.
const initialState: TNoticeState = {
  message: null,
  type: null,
};

const noticeSlice = createSlice({
  name: 'notice',
  initialState,
  reducers: {
    setNotice: (state, action: PayloadAction<Partial<TNoticeState>>) => {
      state.message = action.payload.message ?? null;
      state.type = action.payload.type ?? null;
    },
  },
});

export const { setNotice } = noticeSlice.actions;

export default noticeSlice;
